import styled, { css } from "styled-components";

export const RaportWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: #f4f4f4;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;           /* ⬅️ important: no top padding */
  overflow-y: auto;     /* ⬅️ this is the scroll container */
`;


/* 🆕 Scrolling/padded area under TopBar */
export const PageBody = styled.div`
  flex: 1;
  overflow: auto;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 18px;
  }
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  padding: 28px;
  margin: 24px 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);
  }

 /* Modern H2 */
h2 {
  margin: 0 0 16px 0;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 0.2px;
    padding-bottom: 18px;
  /* Responsive size: min 28px, prefers 4vw, max 40px */
  font-size: clamp(28px, 4vw, 40px);

  /* Gradient text (falls back to solid color if unsupported) */
  color: #0f172a; /* fallback */
  background: linear-gradient(135deg, #0ea5e9, #0ea5e9, #0ea5e9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  /* Slight depth */
  text-shadow: 0 1px 0 rgba(0,0,0,0.06);
  position: relative;
}

/* Accent underline */
h2::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -8px;
  
  width: 64px;
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0ea5e9, #0ea5e9, #0ea5e9);
  box-shadow: 0 2px 10px rgba(99,102,241,0.25);
}

/* Dark mode tweak (optional) */
@media (prefers-color-scheme: dark) {
  h2 {
    text-shadow: 0 1px 0 rgba(0,0,0,0.25);
  }
}

/* Reduce motion users (optional) */
@media (prefers-reduced-motion: reduce) {
  h2, h2::after { transition: none; }
}


  @media (max-width: 768px) {
    padding: 18px;
  }
  @media (max-width: 480px) {
    padding: 14px;
    h2 {
      font-size: 18px;
    }
  }
`;

export const TabButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 10px;
  row-gap: 10px;

  padding: 10px 12px;       /* ⬅️ spacing lives here */
  background: #f4f4f4;
  border: 0;                /* ⬅️ avoid double borders */
  border-radius: 0;         /* ⬅️ wrapper already defines the section */
  overflow: visible;

  @media (max-width: 768px) { gap: 8px; row-gap: 8px; }
  @media (max-width: 480px) { gap: 6px; row-gap: 6px; }
`;

export const TabButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 999px;            /* pill */
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;

  /* base (inactive) */
  color: #1f2937;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
  transition: background .18s ease, color .18s ease, border-color .18s ease,
              box-shadow .18s ease, transform .06s ease;

  /* icon follows text color */
  svg { width: 18px; height: 18px; color: inherit; }

  /* hover (inactive) */
  &:hover {
    background: #f1f5f9;
    border-color: #dbe2ea;
    transform: translateY(-1px);
  }

  /* focus ring */
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(11, 116, 229, 0.25);
  }

  /* ACTIVE state */
  ${({ $active }) =>
    $active &&
    `
      color: #ffffff;
      background: #0b74e5;
      border-color: #0b74e5;
      box-shadow: 0 2px 8px rgba(11, 116, 229, 0.25);
    `}

  /* active hover (slightly darker) */
  ${({ $active }) =>
    $active &&
    `
      &:hover {
        background: #0a67cc;
        border-color: #0a67cc;
      }
    `}

  @media (max-width: 768px) { padding: 9px 12px; font-size: 14px; }
  @media (max-width: 560px) { padding: 8px 10px; font-size: 13.5px; gap: 6px; }
  @media (max-width: 420px) {
    padding: 7px 9px; font-size: 13px;
    span { overflow: hidden; text-overflow: ellipsis; max-width: 160px; }
  }
`;

export const TabsBar = styled.div`
  position: sticky;
  top: var(--topbar-height, 56px); /* sits directly under TopBar */
  z-index: 3;
  background: #f4f4f4;

  margin: 0;                /* ⬅️ no gaps */
  padding: 0;               /* ⬅️ let TabButtons handle inner padding */
  border-bottom: 1px solid #e6e6e6;
`;



/* Optional helpers if you need them later */
export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 6px 0 14px 0;
  flex-wrap: wrap;
  gap: 8px;
`;

export const HeaderTitle = styled.h1`
  font-size: 24px;
  margin: 0;
  color: #0f172a;
  letter-spacing: 0.2px;

  @media (max-width: 560px) {
    font-size: 20px;
  }
`;

export const HeaderSubtitle = styled.p`
  margin: 6px 0 0 0;
  color: #475569;
  font-size: 14px;

  @media (max-width: 560px) {
    font-size: 13px;
  }
`;

export const SectionHint = styled.div`
  margin-top: 6px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f4f8ff;
  color: #334155;
  border-left: 4px solid #0b74e5;
  font-size: 14px;

  @media (max-width: 560px) {
    font-size: 13px;
  }
`;
